module.exports = __webpack_public_path__ + "img/signals-logo-white.6b048f21.png";